import { render } from "./PaymentMethodListPage.vue?vue&type=template&id=200a82df&ts=true"
import script from "./PaymentMethodListPage.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__